import { Article, Topic, User } from '../legacy';
import { IGuessWordCards, IUserDetail, TArticleDetail, TComment } from 'shared/models';

interface WithLoadmoreOptions<T> {
  items: T[];
  hasMore: boolean;
  minCursor: number;
  maxCursor: number;
}

export interface IDiscoverData {
  query: string;
  isBanned: false;
  dataFrom: string;
  article: WithLoadmoreOptions<Article>;
  article_v2: WithLoadmoreOptions<{
    article: TArticleDetail;
    author: IUserDetail;
    comments: TComment[];
  }>;
  user: WithLoadmoreOptions<User>;
  hashtag: WithLoadmoreOptions<Topic>;
  guessWordCards: IGuessWordCards;
}

export enum EDiscoverUnavailableReason {
  BANNED = 'banned',
  SERVER_ERROR = 'server_error',
}

export interface IDiscoverUnavailableData {
  query: string;
  unavailableReason: EDiscoverUnavailableReason;
}

export type TDiscoverData = IDiscoverData | IDiscoverUnavailableData;
